export class Store {
  constructor(state) {
    this.state = state;
    this.listeners = new Set();
  }
  subscribe = fn => {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  };
  getSnapshot = () => {
    return this.state;
  };
  update = newState => {
    if (this.state !== newState) {
      this.state = newState;
      this.listeners.forEach(l => l(newState));
    }
  };
  apply(changes) {
    for (const key in changes) {
      if (!Object.is(this.state[key], changes[key])) {
        this.update({
          ...this.state,
          ...changes
        });
        return;
      }
    }
  }
  set(key, value) {
    if (!Object.is(this.state[key], value)) {
      this.update({
        ...this.state,
        [key]: value
      });
    }
  }
}